import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import TitleCardModule from '../../components/TitleCardModule';
import { getGenreHeroImage } from '../../utils/genreHeroImages';

type Genre = { id: number; name: string };

const GenreListPage = () => {
  const { type } = useParams<{ type: 'movie' | 'tv' }>();
  const [genres, setGenres] = useState<Genre[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!type) return;

    (async () => {
      try {
        const res = await fetch(
          `https://api.themoviedb.org/3/genre/${type}/list?api_key=db1a3d4fc9949395b6300a619305310d`
        );
        const data = await res.json();
        setGenres(Array.isArray(data.genres) ? data.genres : []);
      } catch (err) {
        console.error('Failed to fetch genres', err);
        setGenres([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [type]);

  if (loading) return <div className="p-10 text-center">Loading genres…</div>;

  return (
    <div className="p-6 genre-list-page">
      <h2 className="text-3xl font-bold mb-6 text-center">
        {type === 'tv' ? '📺 TV Genres' : '🎬 Movie Genres'}
      </h2>

      <ul className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {genres.map((cat) => (
          <li key={cat.id}>
            <Link
              to={`/genres/${type}/${cat.id}`}
              state={{ genreName: cat.name }}
              className="genre-card-link"
            >
              <TitleCardModule
                title={cat.name}
                imageUrl={getGenreHeroImage(cat.id)}
              />
            </Link>
          </li>
        ))}
      </ul>

      <p className="genre-list-attribution">
        Genre photos from{' '}
        <a
          href="https://unsplash.com/?utm_source=flixtor&utm_medium=referral"
          target="_blank"
          rel="noreferrer"
        >
          Unsplash
        </a>
        {' '}
        (free to use under the{' '}
        <a
          href="https://unsplash.com/license"
          target="_blank"
          rel="noreferrer"
        >
          Unsplash License
        </a>
        ).
      </p>
    </div>
  );
};

export default GenreListPage;